// @ts-nocheck



import { createSlice } from '@reduxjs/toolkit';

import { fuelMultiplierApi as api } from './../lib/api';



export const FETCH_FUEL_MULTIPLIER = 'vehicles/fuelMultiplier/fetch';
export const ADD_FUEL_MULTIPLIER = 'vehicles/fuelMultiplier/add';
export const UPDATE_FUEL_MULTIPLIER = 'vehicles/fuelMultiplier/update';
export const DELETE_FUEL_MULTIPLIER = 'vehicles/fuelMultiplier/delete';
export const CLEAN_FUEL_MULTIPLIER = 'vehicles/fuelMultiplier/clean';



const fuelMultiplierSlice = createSlice({
  name: 'vehicles/fuelMultiplier',
  initialState: null,
  reducers: {
    fetch: (state, { payload }) => payload,
    add: (state, { payload }) => payload,
    update: (state, { payload }) => payload,
    delete: (state, { payload }) => payload,
    clean: () => null
  }
});

export const fuelMultiplierActions = fuelMultiplierSlice.actions;

export const addFuelMultiplier = (
multiplier) =>
async (dispatch) => {
  const created = await api.addFuelMultiplier(multiplier);

  dispatch(fuelMultiplierActions.add(created));
};

export const fetchFuelMultiplier = (id) => async (
dispatch) =>
{
  const created = await api.fetchFuelMultiplier(id);

  dispatch(fuelMultiplierActions.fetch(created));
};

export const updateFuelMultiplier = (
multiplier) =>
async (dispatch) => {
  const created = await api.updateFuelMultiplier(multiplier);

  dispatch(fuelMultiplierActions.update(created));
};

export const deleteFuelMultiplier = (
multiplier) =>
async (dispatch) => {
  const created = await api.deleteFuelMultiplier(parseInt(multiplier.id, 10));

  dispatch(fuelMultiplierActions.delete(created));
};

export const updateVehicleFuelMultiplier = (
vehicle,
multipliers) =>
async (dispatch) => {
  if (vehicle.fuelMultipliers) {
    for (let i = 0; i < vehicle.fuelMultipliers.length; i++) {
      let m = vehicle.fuelMultipliers[i];
      await api.deleteVehicleFuelMultiplier(vehicle.id, parseInt(m.id, 10));
    }
  }

  for (let i = 0; i < multipliers.length; i++) {
    let m = multipliers[i];
    await api.addVehicleFuelMultiplier(vehicle.id, parseInt(m.id, 10));
  }
};

export const cleanFuelMultiplier = () => async (
dispatch) =>

dispatch(fuelMultiplierActions.clean());

export default fuelMultiplierSlice.reducer;
